import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableRow, TableCell, TableFooter } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';

import Icon from 'src/components/Icon/Icon';
import { RootState } from 'src/configs/store';
import './CashLog.scss';

interface CashLogProps {
  handleModal: Function
}

function CashLog({ handleModal }: CashLogProps) {
  const { toGet } = useSelector((state:RootState) => state.peripherals.payments);
  const { t } = useTranslation();
  const { transactions } = useSelector((state:RootState) => state.peripherals);
  const [page, setPage] = useState(0);
  const [newTransactions, setNewTransactions] = useState([]);

  useEffect(() => {
    if (transactions.length > 0){
      setNewTransactions(_.reverse(transactions));
    }
  }, [transactions]);

  return (
    <div className="cashlog__history-modal" >
      <div className="cashlog__history-modal-draggable">
        <div className="cashlog__history-modal-title">
          <div className="cashlog__history-modal-title--container">
            <div className="cashlog__history-modal-title--icons">
              <Icon
                className="cashlog__history-icon"
                icon="history"
              />
              <span>{ t('footer.cashLog') }</span>
            </div>
            <div className="cashlog__history-modal-title--toget">
              <span>{ t('footer.toGet') }:</span>
              <span>{ (toGet / 100).toFixed(2) }</span>
            </div>
            <Icon
              className="cashlog__history-modal-title--close"
              icon="close"
              onClick={ handleModal }
            />
          </div>
        </div>
        <div className="cashlog__history-modal-body">
          <Table>
            <TableBody>
              {
                newTransactions.slice(page * 8, page * 8 + 8).map((row, index) => {
                  return (
                    <TableRow key={ index }>
                      <TableCell>{ row.dateTime }</TableCell>
                      <TableCell>{ row.action }</TableCell>
                      <TableCell>{ row.info }</TableCell>
                      <TableCell>{ row.value }</TableCell>
                      <TableCell>{ row.addedValue }</TableCell>
                    </TableRow>
                  );
                })
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell colSpan={ 5 }>
                  <div className="cashlog__pagination">
                    {
                      _.map(new Array(Math.ceil(newTransactions.length / 8)), (p, i) => (
                        <span
                          key={ i }
                          className={ classNames({ 'active': page === i }) }
                          onClick={ () => setPage(i) }
                        >
                          { i + 1 }
                        </span>
                      ))
                    }
                  </div>
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </div>
    </div>
  );

}

export default CashLog;
